import type { ReactNode } from 'react'

import { Tag, type CatalogTagTone } from '@/shared/components/ui/tag'
import { cn } from '@/shared/lib/utils'

export type CatalogBadgeTone = CatalogTagTone

type Props = {
  children: ReactNode
  tone?: CatalogBadgeTone
  className?: string
}

/** 列表卡片封面角标 */
export function CatalogBadge({ children, tone = 'glass', className }: Props) {
  return (
    <Tag variant={tone} className={cn(className)}>
      {children}
    </Tag>
  )
}
